import React, { useState } from 'react'
import { DealSpot } from '../classes/DealSpot'
import { ClientDealVanillaForm } from '../classes/ClientDealVanillaForm'
import { DealVanilla } from '../classes/DealVanilla'
import { ClientDealDigitalOptionForm } from '../classes/ClientDealDigitalOptionForm'
import { DealDigitalOption } from '../classes/DealDigitalOption'
import { ClientDealDigitalKnockInKnockOutForm } from '../classes/ClientDealDigitalKnockInKnockOutForm'
import { DealDigitalKnockInKnockOut } from '../classes/DealDigitalKnockInKnockOut'
import { ClientDealDigitalDoublesForm } from '../classes/ClientDealDigitalDoublesForm'
import { DealDigitalDoubles } from '../classes/DealDigitalDoubles'
import { ClientDealDoubleNoTouchOptionForm } from '../classes/ClientDealDoubleNoTouchOptionForm'
import { DealDoubleNoTouchOption } from '../classes/DealDoubleNoTouchOption'
import { ClientDealMoreDoublesForm } from '../classes/ClientDealMoreDoublesForm'
import { DealMoreDoubles } from '../classes/DealMoreDoubles'
import { ClientDealTouchOptionsForm } from '../classes/ClientDealTouchOptionsForm'
import { DealTouchOptions } from '../classes/DealTouchOptions'
import { ClientDealEnhancedReverseOptionsForm } from '../classes/ClientDealEnhancedReverseOptionsForm'
import { DealEnhancedReverseOptions } from '../classes/DealEnhancedReverseOptions'
import { ClientDealRemainingOptionsForm } from '../classes/ClientDealRemainingOptionsForm'
import { DealRemainingOptions } from '../classes/DealRemainingOptions'
import { ClientSwapForm } from '../classes/ClientSwapForm'
import { DealSwap } from '../classes/DealSwap'
import { DealForward } from '../classes/DealForward'
import { DealNDF } from '../classes/DealNDF'
import { webSocketWorkerEvent } from '../../../services'
import dayjs from 'dayjs'
import { DATE_FORMAT, DEAL_GROUP } from '../../../utils/constants'
import DigitalOptionTrade from '../../Trade/components/DigitalOption/DigitalOptionTrade'
import DigitalKnockInKnockOutTrade from '../../Trade/components/DigitalKnockInKnockOut/DigitalKnockInKnockOutTrade'
import DigitalDoublesTrade from '../../Trade/components/DigitalDoubles/DigitalDoublesTrade'
import MoreDoublesTrade from '../../Trade/components/MoreDoubles/MoreDoublesTrade'
import RemainingOptionsTrade from '../../Trade/components/RemainingOptions/RemainingOptionsTrade'
import DealForm from '../classes/DealForm'
import DoubleNoTouchOptionTrade from '../../Trade/components/DoubleNoTouchOption/DoubleNoTouchOptionTrade'
import TouchOptionsTrade from '../../Trade/components/TouchOptions/TouchOptionsTrade'
import EnhancedReverseOptionTrade from '../../Trade/components/EnhancedReverseOption/EnhancedReverseOptionTrade'

const useDealSetting = ({
  form,
  setForm,
  page,
  setPage,
  currencyInitial,
  currencyData,
  currencyNormalize,
  tradingAccountPrimeBrokerNormalize,
  errors,
  setErrors
}) => {
  const [swapOption, setSwapOption] = useState(false)

  const validateWindowsStartAndWindowsEnd = () => {
    if (form.window_start === '' && form.window_end === '') {
      return true
    }

    if (
      !(
        dayjs(form.window_start).isBefore(dayjs(form.window_end)) ||
        dayjs(form.window_start).isSame(dayjs(form.window_end))
      )
    ) {
      setErrors({ ...errors, window_start: "date can't be after window end" })
      return false
    }
    return true
  }

  const disabled = () => {
    if (errors.currency_pair) {
      return true
    }

    const disabledField = (formKey, formValue) => {
      if (
        [
          'quantity',
          'strike',
          'client_price',
          'market_maker_price',
          'client_premium_amount',
          'market_maker_premium_amount',
          'payout_amount',
          'spot_ref',
          'barrier',
          'lower_barrier',
          'upper_barrier',
          'client_far_price',
          'market_maker_far_price',
          'far_leg_quantity'
        ].includes(formKey) &&
        +formValue === 0
      ) {
        return true
      }
      if (['client_note', 'market_maker_note', 'bdr'].includes(formKey) && formValue === '') {
        return false
      }
      if (['client_trader_name', 'market_maker_trader_name'].includes(formKey) && !formValue) {
        if (!['Spot', 'Swap', 'Forward', 'NDF'].includes(form.deal_type?.deal_type_group)) {
          return false
        } else {
          return true
        }
      }

      if (['string', 'number'].includes(typeof formValue)) {
        return !formValue
      } else if (typeof formValue === 'object') {
        return !formValue.name
      }
    }
    let deal
    switch (form?.deal_type?.deal_type_group) {
      case DEAL_GROUP.SPOT: {
        deal = new DealSpot(form, tradingAccountPrimeBrokerNormalize)
        break
      }
      case DEAL_GROUP.VANILLA_OPTION:
        if (form.deal_type.deal_type_group === DEAL_GROUP.VANILLA_OPTION && page === false) {
          deal = new ClientDealVanillaForm(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        } else {
          deal = new DealVanilla(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        }
        break
      case DEAL_GROUP.DIGITAL_OPTION:
        if (form.deal_type.deal_type_group === DEAL_GROUP.DIGITAL_OPTION && page === false) {
          deal = new ClientDealDigitalOptionForm(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        } else {
          deal = new DealDigitalOption(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        }
        break
      case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS:
        if (
          form.deal_type.deal_type_group === DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS &&
          page === false
        ) {
          deal = new ClientDealDigitalKnockInKnockOutForm(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        } else {
          deal = new DealDigitalKnockInKnockOut(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        }
        break
      case DEAL_GROUP.DIGITAL_DOUBLES:
        if (form.deal_type.deal_type_group === DEAL_GROUP.DIGITAL_DOUBLES && page === false) {
          deal = new ClientDealDigitalDoublesForm(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        } else {
          deal = new DealDigitalDoubles(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        }
        break
      case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION:
        if (
          form.deal_type.deal_type_group === DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION &&
          page === false
        ) {
          deal = new ClientDealDoubleNoTouchOptionForm(form, tradingAccountPrimeBrokerNormalize)
        } else {
          deal = new DealDoubleNoTouchOption(form, tradingAccountPrimeBrokerNormalize)
        }
        break
      case DEAL_GROUP.MORE_DOUBLES:
        if (form.deal_type.deal_type_group === DEAL_GROUP.MORE_DOUBLES && page === false) {
          deal = new ClientDealMoreDoublesForm(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        } else {
          deal = new DealMoreDoubles(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        }
        break
      case DEAL_GROUP.TOUCH_OPTIONS:
        if (form.deal_type.deal_type_group === DEAL_GROUP.TOUCH_OPTIONS && page === false) {
          deal = new ClientDealTouchOptionsForm(form, tradingAccountPrimeBrokerNormalize)
        } else {
          deal = new DealTouchOptions(form, tradingAccountPrimeBrokerNormalize)
        }
        break
      case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS:
        if (
          form.deal_type.deal_type_group === DEAL_GROUP.ENHANCED_REVERSE_OPTIONS &&
          page === false
        ) {
          deal = new ClientDealEnhancedReverseOptionsForm(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        } else {
          deal = new DealEnhancedReverseOptions(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        }
        break
      case DEAL_GROUP.REMAINING_OPTIONS:
        if (form.deal_type.deal_type_group === DEAL_GROUP.REMAINING_OPTIONS && page === false) {
          deal = new ClientDealRemainingOptionsForm(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        } else {
          deal = new DealRemainingOptions(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
        }
        break
      case DEAL_GROUP.SWAP:
        if (form.deal_type.deal_type_group === DEAL_GROUP.SWAP && page === false) {
          deal = new ClientSwapForm(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        } else {
          deal = new DealSwap(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        }
        break
      case DEAL_GROUP.FORWARD:
        deal = new DealForward(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.NDF:
        deal = new DealNDF(form, tradingAccountPrimeBrokerNormalize)
        break
      default:
        return true
    }
    return Object.entries(deal).some(([key, value]) => disabledField(key, value))
  }
  const submitForm = () => {
    if (
      ![DEAL_GROUP.SPOT, DEAL_GROUP.SWAP, DEAL_GROUP.FORWARD, DEAL_GROUP.NDF].includes(
        form.deal_type.deal_type_group
      ) &&
      page === false
    ) {
      //check window start window end
      const validationImprove = validateWindowsStartAndWindowsEnd()
      //if validation improve and also the currency pair is correct can move to next page
      if (validationImprove && !errors.currency_pair) {
        if (errors.window_start) {
          setErrors({})
        }
        setPage(true)
      }
    } else if ([DEAL_GROUP.SWAP].includes(form.deal_type.deal_type_group) && page === false) {
      setPage(true)
    } else {
      switch (form.deal_type.deal_type_group) {
        case DEAL_GROUP.SPOT: {
          const deal = new DealSpot(form, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.VANILLA_OPTION: {
          const deal = new DealVanilla(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.DIGITAL_OPTION: {
          const deal = new DealDigitalOption(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS: {
          const deal = new DealDigitalKnockInKnockOut(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION: {
          const deal = new DealDoubleNoTouchOption(form, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.DIGITAL_DOUBLES: {
          const deal = new DealDigitalDoubles(form, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.MORE_DOUBLES: {
          const deal = new DealMoreDoubles(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.TOUCH_OPTIONS: {
          const deal = new DealTouchOptions(form, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS: {
          const deal = new DealEnhancedReverseOptions(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }

        case DEAL_GROUP.REMAINING_OPTIONS: {
          const deal = new DealRemainingOptions(
            form,
            currencyNormalize,
            tradingAccountPrimeBrokerNormalize
          )
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }
        case DEAL_GROUP.SWAP: {
          const deal = new DealSwap(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }
        case DEAL_GROUP.FORWARD: {
          const deal = new DealForward(form, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }
        case DEAL_GROUP.NDF: {
          const deal = new DealNDF(form, tradingAccountPrimeBrokerNormalize)
          webSocketWorkerEvent.sendEvent({
            type: 'create_deal',
            data: deal
          })
          break
        }
        default:
          return
      }
    }
    setForm({ ...form, trade_date: dayjs().format(DATE_FORMAT.REGULAR_DATE_TIME) })
  }

  const resetForm = dealType => {
    const newForm = new DealForm({ deal_type: dealType })
    if (swapOption) {
      setSwapOption(false)
    }
    setForm(newForm)
    setPage(false)
    setErrors({})
  }

  const checkPrimeBrokerIsRBS = () => {
    const tradingAccountPrimeBrokerForClient =
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker[form.client]
    const tradingAccountPrimeBrokerForMarketMaker =
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker[form.market_maker]
    if (
      form.client &&
      tradingAccountPrimeBrokerForClient &&
      tradingAccountPrimeBrokerForClient.prime_broker === 'RBS' &&
      !form.market_maker
    ) {
      return true
    } else if (
      form.client &&
      tradingAccountPrimeBrokerForClient &&
      tradingAccountPrimeBrokerForClient.prime_broker === 'RBS' &&
      form.market_maker &&
      tradingAccountPrimeBrokerForMarketMaker &&
      tradingAccountPrimeBrokerForMarketMaker.prime_broker === 'RBS'
    ) {
      return true
    } else {
      return false
    }
  }

  const handelBackButtonVanillaDeal = () => {
    setPage(false)
  }

  const handelFormChange = (event, element) => {
    const copyForm = { ...form }
    let { name, value } = event.target
    if (
      [
        'client',
        'deal_type',
        'payout_currency',
        'market_maker',
        'trade_origin',
        'cut',
        'fixing_source',
        'client_premium_currency',
        'market_maker_premium_currency',
        'client_option_payment_currency',
        'market_maker_option_payment_currency',
        'client_trader_name',
        'market_maker_trader_name'
      ].includes(name)
    ) {
      if (name === 'deal_type') {
        return resetForm(element)
      } else if (name === 'client') {
        copyForm[name] = element.split(' ').slice(0, -1).join(' ')
        if (form.client_trader_name !== '') {
          copyForm.trader_name = ''
        }
      } else if (name === 'market_maker') {
        copyForm[name] = element.split(' ').slice(0, -1).join(' ')
        if (form.market_maker_trader_name !== '') {
          copyForm.market_maker_trader_name = ''
        }
        if (
          form?.deal_type?.deal_type_group === DEAL_GROUP.SWAP &&
          ['market_maker', 'client'].includes(name)
        ) {
          const counterparty = element.split(' ').slice(0, -1).join(' ')
          handelSwapDeal(counterparty)
        }
      } else {
        copyForm[name] = element
      }
    } else if (
      [
        'quantity',
        'strike',
        'client_price',
        'market_maker_price',
        'client_premium_amount',
        'market_maker_premium_amount',
        'payout_amount',
        'spot_ref',
        'barrier',
        'lower_barrier',
        'upper_barrier',
        'client_far_price',
        'market_maker_far_price',
        'far_leg_quantity'
      ].includes(name) &&
      ((!isNaN(value) && +value >= 0) ||
        value === '' ||
        (String(value).length > 1 &&
          String(value).endsWith('.') &&
          String(value).split('.').length < 3))
    ) {
      if (
        String(value).length > 1 &&
        String(value).endsWith('.') &&
        String(value).split('.').length < 3
      ) {
        copyForm[name] = value
      } else if (value === '') {
        copyForm[name] = value
      } else {
        copyForm[name] = value
      }
    } else if (
      [
        'currency_pair',
        'put_call',
        'option_exercise_style',
        'client_side',
        'timing',
        'client_note',
        'market_maker_note',
        'bdr'
      ].includes(name)
    ) {
      if (name === 'currency_pair') {
        if (value.length < 7) {
          copyForm[name] = value.toUpperCase()
        }
      } else {
        copyForm[name] = value
      }
    } else if (['is_structure', 'is_pba'].includes(name)) {
      copyForm[name] = event.target.checked
    }
    setForm(copyForm)
  }

  const handelDateChange = (name, value) => {
    const copyForm = { ...form }
    if (
      [
        'trade_date',
        'client_value_date',
        'fixing_date',
        'market_maker_value_date',
        'client_premium_date',
        'market_maker_premium_date',
        'settlement_date',
        'expiry',
        'window_start',
        'window_end',
        'client_far_value_date',
        'market_maker_far_value_date',
        'far_fixing_date'
      ].includes(name)
    ) {
      copyForm[name] = value
      setForm(copyForm)
    }
  }

  const getTradeTemplateGridRow = () => {
    if (['', 'Spot', 'NDF', 'Swap', 'Forward'].includes(form.deal_type.deal_type_group)) {
      return { gridTemplateColumns: 'repeat(2,1fr)' }
    } else {
      return { gridTemplateColumns: 'repeat(3,1fr)' }
    }
  }

  const handelFocusCurrencyPair = () => {
    setErrors({ ...errors, currency_pair: '' })
  }

  const handelBlurCurrencyPair = () => {
    if (form?.deal_type?.deal_type_group === DEAL_GROUP.SWAP) {
      const flag = page === false ? handelSwapDeal(form.client) : handelSwapDeal(form.market_maker)
      if (flag) {
        return
      }
    }
    if (form.currency_pair !== '') {
      if (form.currency_pair.length !== 6) {
        setErrors({ ...errors, currency_pair: 'currency too short' })
        return
      }
      const baseCurrency = form.currency_pair.substring(0, 3)
      const counterCurrency = form.currency_pair.substring(3, 6)

      const baseCurrencyInfo = currencyNormalize.data[baseCurrency]
      const counterCurrencyInfo = currencyNormalize.data[counterCurrency]

      if (baseCurrencyInfo && counterCurrencyInfo && baseCurrencyInfo === counterCurrencyInfo) {
        setErrors({ ...errors, currency_pair: "currencies can't be the same" })
        return
      }

      if (!baseCurrencyInfo && !counterCurrencyInfo) {
        setErrors({ ...errors, currency_pair: 'currencies not found' })
        return
      }

      if (!baseCurrencyInfo) {
        setErrors({ ...errors, currency_pair: 'base currency not found' })
        return
      }

      if (!counterCurrencyInfo) {
        setErrors({ ...errors, currency_pair: 'counter currency not found' })
        return
      }
    }
  }

  const handelSwapDeal = () => {
    if (form.currency_pair.length >= 3) {
      const baseCurrency = form.currency_pair.substring(0, 3)
      const counterCurrency = form.currency_pair.substring(3, 6)
      const baseCurrencyInfo = currencyNormalize.data[baseCurrency]
      const counterCurrencyInfo = currencyNormalize.data[counterCurrency]
      if (form.currency_pair.length >= 3 && baseCurrencyInfo?.is_ndf) {
        setSwapOption(true)
      } else if (form.currency_pair.length === 6 && counterCurrencyInfo?.is_ndf) {
        setSwapOption(true)
      } else {
        setSwapOption(false)
      }
    } else if (swapOption) {
      setSwapOption(false)
    }
  }

  const disabledField = () => {
    const disabledFormField = {
      put_call: false,
      fixing_source: false,
      fixing_date: false,
      strike: false
    }

    const { deal_type, currency_pair } = form || {}
    const dealGroup = deal_type?.deal_type_group

    const disableFixingIfNotNDF = () => {
      const baseCurrency = currency_pair?.substring(0, 3)
      const counterCurrency = currency_pair?.substring(3, 6)
      const baseInfo = currencyNormalize?.data?.[baseCurrency]
      const counterInfo = currencyNormalize?.data?.[counterCurrency]
      if (!baseInfo?.is_ndf && !counterInfo?.is_ndf) {
        disabledFormField.fixing_date = true
        disabledFormField.fixing_source = true
        if (form.fixing_source) {
          setForm({ ...form, fixing_source: '' })
        }
      }
    }
    const disableFixingDateIfNotNDF = () => {
      const baseCurrency = currency_pair?.substring(0, 3)
      const counterCurrency = currency_pair?.substring(3, 6)
      const baseInfo = currencyNormalize?.data?.[baseCurrency]
      const counterInfo = currencyNormalize?.data?.[counterCurrency]
      if (!baseInfo?.is_ndf && !counterInfo?.is_ndf) {
        disabledFormField.fixing_date = true
      }
    }

    switch (dealGroup) {
      case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION:
      case DEAL_GROUP.TOUCH_OPTIONS:
        Object.assign(disabledFormField, {
          fixing_date: true,
          fixing_source: true,
          strike: true,
          put_call: true
        })
        break
      case DEAL_GROUP.DIGITAL_OPTION:
      case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS:
      case DEAL_GROUP.DIGITAL_DOUBLES:
      case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS:
        disableFixingDateIfNotNDF()
        break
      case DEAL_GROUP.VANILLA_OPTION:
      case DEAL_GROUP.MORE_DOUBLES:
      case DEAL_GROUP.REMAINING_OPTIONS:
        disableFixingIfNotNDF()
        break

      default:
        break
    }

    return disabledFormField
  }

  const exoticDealBody = () => {
    const disabled = page
    switch (form?.deal_type?.deal_type_group) {
      case DEAL_GROUP.DIGITAL_OPTION:
        return (
          <DigitalOptionTrade
            form={form}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            disabled={disabled}
          />
        )

      case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS:
        return (
          <DigitalKnockInKnockOutTrade
            form={form}
            errors={errors}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            disabled={disabled}
          />
        )

      case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION:
        return (
          <DoubleNoTouchOptionTrade
            form={form}
            errors={errors}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            disabled={disabled}
          />
        )

      case DEAL_GROUP.DIGITAL_DOUBLES:
        return (
          <DigitalDoublesTrade
            form={form}
            errors={errors}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            disabled={disabled}
          />
        )

      case DEAL_GROUP.MORE_DOUBLES:
        return (
          <MoreDoublesTrade
            form={form}
            errors={errors}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            disabled={disabled}
          />
        )

      case DEAL_GROUP.TOUCH_OPTIONS:
        return (
          <TouchOptionsTrade
            form={form}
            errors={errors}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            disabled={disabled}
          />
        )

      case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS:
        return (
          <EnhancedReverseOptionTrade
            form={form}
            errors={errors}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            disabled={disabled}
          />
        )

      case DEAL_GROUP.REMAINING_OPTIONS:
        return (
          <RemainingOptionsTrade
            form={form}
            errors={errors}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            disabled={disabled}
          />
        )

      default:
        return
    }
  }

  const getContinueButtonTitle = () => {
    if (
      [DEAL_GROUP.SPOT, '', DEAL_GROUP.FORWARD, DEAL_GROUP.NDF].includes(
        form.deal_type.deal_type_group
      )
    ) {
      return 'Create Deal'
    } else {
      if (page === false) {
        return 'Market Side >'
      }
      if (page === true) {
        return 'Create Deal'
      }
    }
  }

  return {
    getContinueButtonTitle,
    disabled,
    disabledField,
    submitForm,
    handelDateChange,
    handelFormChange,
    exoticDealBody,
    handelBackButtonVanillaDeal,
    handelFocusCurrencyPair,
    handelBlurCurrencyPair,
    getTradeTemplateGridRow,
    swapOption,
    checkPrimeBrokerIsRBS
  }
}

export default useDealSetting
